/**
 * ============================================
 * API Configuration
 * ============================================
 */

export const API_BASE_URL = process.env.REACT_APP_IS_DEVELOPMENT === 'true' ? 'http://localhost:5000/api/v1' : 'http://api.ecommercetn.me/api/v1';
export const IMAGE_BASE_URL = 'http://api.ecommercetn.me';

console.log('API Base URL:', API_BASE_URL);
console.log('IMAGE Base URL:', IMAGE_BASE_URL);
console.log('IS_DEVELOPMENT:', process.env.REACT_APP_IS_DEVELOPMENT);

/**
 * Get full image URL from relative path
 */
export const getImageUrl = (imagePath) => {
    if (!imagePath) return null;
    if (imagePath.startsWith('http')) return imagePath;
    return `${IMAGE_BASE_URL}${imagePath}`;
};
/**
 * Generic API request handler
 */
export const apiRequest = async (endpoint, options = {}) => {
    const url = `${API_BASE_URL}${endpoint}`;
    
    const defaultOptions = {
        mode: 'cors',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        ...options
    };

    try {
        const response = await fetch(url, defaultOptions);
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('API Error:', error);
        throw error;
    }
};

export default API_BASE_URL;
